import { useState, useEffect } from 'react';

export const useCats = () => {
  const [cats, setCats] = useState(() => {
    if (typeof window === 'undefined') {
      return [];
    }

    try {
      const savedCats = window.localStorage.getItem('cats');
      return savedCats ? JSON.parse(savedCats) : [];
    } catch (error) {
      console.warn('Failed to read cats from localStorage', error);
      return [];
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      window.localStorage.setItem('cats', JSON.stringify(cats));
    } catch (error) {
      console.warn('Failed to save cats to localStorage', error);
    }
  }, [cats]);

  // Create: Add a new cat
  const addCat = (cat) => {
    const newCat = {
      ...cat,
      id: Date.now().toString()
    };
    setCats([...cats, newCat]);
  };

  // Read: Get cat by id
  const getCatById = (id) => {
    return cats.find(cat => cat.id === id);
  };

  // Update: Edit existing cat
  const updateCat = (id, updatedCat) => {
    setCats(cats.map(cat => 
      cat.id === id ? { ...cat, ...updatedCat, id } : cat
    ));
  };

  // Delete: Remove cat
  const deleteCat = (id) => {
    if (window.confirm('Are you sure you want to remove this cat?')) {
      setCats(cats.filter(cat => cat.id !== id));
    }
  };

  return {
    cats,
    addCat,
    getCatById,
    updateCat,
    deleteCat
  };
};
